module.exports = __webpack_public_path__ + "static/img/xfstb.77eba93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xfstb.jpg
// module id = iqNt
// module chunks = 21